import { Routes } from '@angular/router';
import { NotFoundComponent } from './modules/static-page/not-found/not-found.component';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth-routing.module').then(m => m.routes),
  },
  {
    path: 'user',
    loadChildren: () =>
      import('./modules/user/user-routing.module').then(m => m.routes),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./modules/dashboard/dashboard-routing-module').then(m => m.routes),
  },
  {
    path: 'legal',
    loadChildren: () =>
      import('./modules/legal/legal-routing.module').then(m => m.LEGAL_ROUTES),
  },
  {
    path: 'amenities',
    loadChildren: () =>
      import('./modules/amenity/amenity-routing.module').then(m => m.AMENITY_ROUTES),
  },
  {
    path: 'reports',
    loadChildren: () =>
      import('./modules/report/report-routing.module').then(m => m.REPORT_ROUTES),
  },
  {
    path: 'property-ranking',
    loadChildren: () =>
      import('./modules/property-ranking/property-ranking-routing.module').then(m => m.PROPERTY_RANKING_ROUTES),
  },
  {
    path: 'email-sender',
    loadChildren: () =>
      import('./modules/email-sender/email-sender-routing.module').then(m => m.EMAIL_SENDER_ROUTES),
  },
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: '**', component: NotFoundComponent },
];

